var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { HOST_Server, PARAM_FrontEnd_ShareId, PATH_APICURRENTVERSION, PATH_PUBLIC_SharedRecipes } from '../../config/config.dev';
import Layout from '../Layouts/Layout';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import RecipeView from '../Recipes/RecipeView';
import { trackPageView } from '../Telemetry/AppInsights';
import { useEffect, useState } from 'react';
import { Telemetry } from '../Telemetry/TelemtryEventNames';
import Server404 from '../NotFound/Server404';
var SpicePackPage = function (props) {
    var usid = props.usid, isShareOnly = props.isShareOnly, isSpicePack = props.isSpicePack, isDeepLink = props.isDeepLink;
    var _a = useState(), recipe = _a[0], setRecipe = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    // Use the useLocation hook to get the current location
    var location = useLocation();
    // Parse the query parameters from the location's search property
    var queryParams = new URLSearchParams(location.search);
    // Extract the usid parameter from the parsed query parameters ifone is not provided in props.
    var requestUsid = !usid ? queryParams.get(PARAM_FrontEnd_ShareId) : usid;
    useEffect(function () {
        var event = isSpicePack ? Telemetry.PageView.SpicePackDeepLink : Telemetry.PageView.SharePageDeepLink;
        trackPageView(event);
    }, []);
    useEffect(function () {
        function getUserRecipes() {
            return __awaiter(this, void 0, void 0, function () {
                var response, metadata, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, 6, 7]);
                            return [4 /*yield*/, fetch("".concat(HOST_Server).concat(PATH_APICURRENTVERSION).concat(PATH_PUBLIC_SharedRecipes, "?usid=").concat(requestUsid))];
                        case 1:
                            response = _a.sent();
                            if (!(response.status === 400)) return [3 /*break*/, 2];
                            setIsError(true);
                            setTimeout(function () {
                                window.location.href = HOST_Server;
                            }, 5000);
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, response.json()];
                        case 3:
                            metadata = _a.sent();
                            setRecipe(metadata);
                            _a.label = 4;
                        case 4: return [3 /*break*/, 7];
                        case 5:
                            error_1 = _a.sent();
                            console.error(error_1);
                            return [3 /*break*/, 7];
                        case 6:
                            setIsLoading(false);
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
        getUserRecipes();
    }, []);
    if (isError) {
        return (_jsx(Layout, { children: _jsx(Server404, { message: "Recipe not found. It may no longer be public or was removed.", image: '404GENIE.png', context: props }) }));
    }
    if (!recipe || (isLoading)) {
        return (_jsx(Layout, { children: _jsx(LoadingScreen, {}) }));
    }
    return (_jsx(Layout, { children: _jsx(RecipeView, { recipe: recipe, isEditable: false, isSpicePack: isSpicePack, isShareOnly: isShareOnly, isDeepLink: isDeepLink }) }));
};
export default SpicePackPage;
